import { BUSINESS_SECTION_TYPE_MLE, mleFields, PREFIX_KYCURLS } from "components/Onboarding/Mle/BusinessTab/contants";
import { FORMAT_DATE, GST, KYC_FILES } from "components/Onboarding/Mle/mle.constants";
import { fetchFieldValue, setFieldValue } from "components/Onboarding/Mle/mle.utils";
import { UBO_SECTION_TYPE, uboDeclarationUrls } from "components/Onboarding/Mle/UobTab/constant";
import { inProcessMock } from "mockApiWiseReqRes";
import moment from "moment";
import { toast } from "react-toastify";
import { apiStatusCodes } from "utils/API/apiStatusCodes";
import { API_FORM_IN_PROCESS } from "utils/API/apiUrls";
import { FORM_TYPE, MAKER_CHECKER_EVENT_TYPES_MLE, MOCK_API_VALUE } from "utils/constants/commonValues";
import { POST } from "utils/fetchWrappers";
import { createDeepCopyObj } from "utils/helperMethods";

const formatDate = (dateString, format = FORMAT_DATE) => {
    const date = moment(dateString);
    
    if (date.isValid()) {
        return date.format(format);
    } else {
        return dateString;
    }
};


export const mutateMleDataMerchant = (data, sectionType) => {
    
    let resp = createDeepCopyObj(data);
    try {
        
        if (sectionType === BUSINESS_SECTION_TYPE_MLE || sectionType?.toLowerCase() === MAKER_CHECKER_EVENT_TYPES_MLE.business.toLowerCase()) {
            if (typeof data?.telephoneNumbers === 'object' && data?.telephoneNumbers?.length)  
                resp.telephoneNumbers = parseInt(data.telephoneNumbers[0]);
            if (typeof data?.mobileNumbers === 'object' && data?.mobileNumbers?.length)
                resp.mobileNumbers = parseInt(data.mobileNumbers[0]);
            
            let panValue = fetchFieldValue(data, mleFields.panUpload.reqname);
            if (panValue && panValue != {}) {
                setFieldValue(resp, mleFields.panUpload.name, {
                    name: mleFields.panUpload.name,
                    value: {name: panValue?.split('/').pop()}
                });
            }
            
            if (data?.[PREFIX_KYCURLS]?.[GST]) {
                let gstUrlValue = data?.[PREFIX_KYCURLS]?.[GST]?.toString();
                resp[mleFields.gstUpload.name] = {
                    name: mleFields.gstUpload.name,
                    value: {name: gstUrlValue}
                };
                resp[mleFields.gstUpload.reqName] = gstUrlValue;
                delete resp[PREFIX_KYCURLS][GST];
            }
            if (data?.[mleFields.gst.name]) {
                resp[mleFields.gst.name] = data?.[mleFields.gst.name]?.toString();
                setFieldValue(resp, mleFields.verifyGst.name, true);
            }
            if (data?.[mleFields.panDate.name] || data?.['panDetails.dob'] || data?.panDetails?.dob) {
                resp[mleFields.panDate.name] = formatDate(data?.['panDetails.dob'] || data?.panDetails?.dob || data[mleFields.panDate.name]);
            }

            if (!fetchFieldValue(resp, mleFields.pan.name)) {
                resp.panDetails.panNumber = '';
            }

            if (!fetchFieldValue(resp, mleFields.panName.name)) {
                resp.panDetails.name = '';
            }

            if (!!resp?.[mleFields.panDate.name] && !!fetchFieldValue(resp, mleFields.pan.name) && !!fetchFieldValue(resp, mleFields.panName.name)) {
                setFieldValue(resp, mleFields.verifyPan.name, true);
            }

            if (data?.[PREFIX_KYCURLS]) {
                resp[KYC_FILES] = {};
                Object.keys(data[PREFIX_KYCURLS]).map(key => {                    
                    if (data?.[PREFIX_KYCURLS]?.[key]?.length) {
                        // resp[PREFIX_KYCURLS][key] = data[PREFIX_KYCURLS][key].toString();
                        resp[KYC_FILES][key] = [];
                        // resp[PREFIX_KYCURLS][key] = data[PREFIX_KYCURLS][key].toString();
                    }
                })
            }
        } else if (sectionType === UBO_SECTION_TYPE || sectionType?.toLowerCase() === MAKER_CHECKER_EVENT_TYPES_MLE.ubo.toLowerCase()) {
            if (data[uboDeclarationUrls.reqname]) {
                resp[uboDeclarationUrls.name] = {}; 
                resp[uboDeclarationUrls.reqname] = data[uboDeclarationUrls.reqname].toString();
            }
            if (Array.isArray(data?.uboDetails)) {
                data.uboDetails.map((uboDetailsItem, uboDetailsIdx) => {
                    resp.uboDetails[uboDetailsIdx].panurl = {};
                    resp.uboDetails[uboDetailsIdx].addressFile = {};
                    if (data?.uboDetails?.[uboDetailsIdx]?.panDetails?.dob)
                        resp.uboDetails[uboDetailsIdx].panDetails.dob = formatDate(data.uboDetails[uboDetailsIdx].panDetails.dob);
                    if (data?.uboDetails?.[uboDetailsIdx]?.panDetails?.panNumber && 
                        data?.uboDetails?.[uboDetailsIdx]?.panDetails?.name && 
                        data?.uboDetails?.[uboDetailsIdx]?.panDetails?.dob) {
                        resp.uboDetails[uboDetailsIdx]['verify-pan'] = true;
                    }
                    if (!data?.uboDetails?.[uboDetailsIdx]?.email)
                        resp.uboDetails[uboDetailsIdx].email = '';

                })
            }
        }
    } catch(e) {
        console.log()
    }
    return resp;
}

export const fetchMleDataDraft = async () => {
    try {
        const request = {
            formType: FORM_TYPE.MLE_ON_BOARD,
        };
        let data = {};
        if (MOCK_API_VALUE) {
            data = inProcessMock(FORM_TYPE.MLE_ON_BOARD);
        } else  {
            data = (await POST(API_FORM_IN_PROCESS, request)).data;
        }
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            return data;
        } else if (data?.errorMessage){
            toast.error(data?.errorMessage);
        }
    } catch(e) {

    }
    return {};
}